import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { GLViewRow } from "../glViewTypes";

export const GLSplitCell = React.memo(function GLSplitCell({
    row,
}: CellContext<ViewTableFeatures, GLViewRow, unknown>): React.ReactElement {
    const { rowKind, transaction } = row.original;

    if (rowKind !== "transaction" || !transaction) {
        return <ViewTableCell />;
    }

    return <ViewTableCell>{transaction.splitLabel}</ViewTableCell>;
});
